import "./AddYourServices.scss";
import equipment from './../../assets/images/addYourServices/equipment.png';
import dronelicense from './../../assets/images/addYourServices/drone-license.png';
import certification from './../../assets/images/addYourServices/certification.png';
import verification from './../../assets/images/addYourServices/verification.png';
import social from './../../assets/images/addYourServices/social.png';
import services from './../../assets/images/addYourServices/services.png';
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";

const steps = [
  { id: 1, text: "Add equipment", image: equipment, path:"/dashboard/equipments/add-equipments" },
  { id: 2, text: "Add drone pilot licence", image: dronelicense, path:"/dashboard/licenses/add-license" },
  { id: 3, text: "Add certification", image: certification, path:"/dashboard/certificates/add-certificate" },
  { id: 4, text: "Complete profile verification", image: verification, path:"/dashboard/kycdocuments/add-kycdocument" },
  { id: 5, text: "Link social profile", image: social, path:"/dashboard/social" },
  { id: 6, text: "Add services and start selling", image: services, path:"/dashboard/services/add-services" },
];


const AddYourServices = () => {
  const navigate=useNavigate();
  const handleNavigate=(path)=>{
    navigate(path);
  }
  return (
    <>
    <div className="breadCrumb">
    <BreadCrumb paths={[{name:"Home",path:"/dashboard"},
      {name:"Get Started",path:""}]}/>
      </div>
    <div className="verification-container">
      <h2>Get yourself verified to start listing with Aeria Borne</h2>
      <div className="steps-grid">
        {steps.map((step) => (
          <div key={step.id} className="step-card" onClick={()=>{handleNavigate(step.path)}}>
            <p className="step-number">Step {step.id}</p>
            <img src={step.image} alt={step.text} />
            <p className="step-text">{step.text}</p>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default AddYourServices;
